import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SmsLogs } from '@/pages/super-admin/sms-logs';
import { SMS_CATEGORIES, SMS_STATUSES } from '@/pages/super-admin/sms-log-config';

const smsLogsSearchSchema = z.object({
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(10),
	search: z.coerce.string().optional(),
	status: z.enum(SMS_STATUSES).optional(),
	category: z.enum(SMS_CATEGORIES).optional(),
});

export const Route = createFileRoute('/_authenticated/super-admin/sms-logs')({
	component: SmsLogs,
	validateSearch: smsLogsSearchSchema,
});
